import React, { createContext, PropsWithChildren, useContext } from "react"
import { LoginService } from "./service"

const LoginServiceContext = createContext({} as LoginService)

export const useLoginService = () => useContext(LoginServiceContext)

export const LoginServiceProvider = ({ children, service }: PropsWithChildren & { service: LoginService }) => {
  return (<LoginServiceContext.Provider value={service}>
    {children}
  </LoginServiceContext.Provider>)
}
